module.exports = __webpack_public_path__ + "media/danger2.43d92e59.wav";